import { Car, Circle, Drop, Gear, Lightning, Scan, StopCircle, Wind, Wrench } from '@phosphor-icons/react';

/**
 * Иконки каталога сервисных работ.
 *
 * Раньше `ServiceCard` и `ServiceSelector` делали `import * as Icons` и брали
 * компонент по строке из данных (`Icons[service.iconName]`). Два минуса, и
 * второй серьёзнее первого:
 *
 * 1. namespace-импорт лишает сборку tree-shaking — в бандл может уехать весь
 *    пак, хотя реально нужно девять глифов;
 * 2. связь «строка из данных → компонент» ничем не проверяется. Пришло имя,
 *    которого в паке нет, — молча подставился `Wrench`, и никто не заметил.
 *    Ровно это и случилось бы при переходе на Phosphor (#1329): имена в
 *    `getIconForServiceType` были lucide-шными (`Droplets`, `ScanLine`,
 *    `CarFront`), и в Phosphor таких нет.
 *
 * Список закрытый: имена задаёт `getIconForServiceType` в `serviceApi.js`,
 * бэкенд иконки не присылает. Добавляется тип работ — добавляется строка сюда.
 */
export const SERVICE_ICONS = {
  CarFront: Car,
  Circle,
  CircleStop: StopCircle,
  Droplets: Drop,
  ScanLine: Scan,
  Settings: Gear,
  Wind,
  Wrench,
  Zap: Lightning,
};

/** Компонент иконки по имени из данных; `Wrench` — заведомо существующий фоллбэк. */
export const serviceIcon = (name) => SERVICE_ICONS[name] || Wrench;
